import PlatformActions from './PlatformActions'

export default class OCTOPLAYActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'OCTOPLAY',
      gameType: 'SLOT',
      gameCode: 'OCTOPLAY-SLOT-038',
    }

    this.gameName = 'Buffalo Smash'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `OP051-oct-${roundId}_OP051-oct-${wagerId}`, // OOP051-oct-303107f3-0dd7-46aa-9e3c-00000000b88a_OP051-oct-303107f3-0dd7-46aa-9e3c-000000016e3
      roundId: `OP051-oct-${roundId}`, // OOP051-oct-303107f3-0dd7-46aa-9e3c-00000000b88a
      betType: null,
      currency,
      betTime, // 2025-09-19T11:11:37.000+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        betType: '1',
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      isEndRound = true,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `OP051-oct-${roundId}_OP051-oct-${wagerId}`, // OP051-oct-303107f3-0dd7-46aa-9e3c-00000000b88a_OP051-oct-303107f3-0dd7-46aa-9e3c-000000016e3c
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2025-09-19T10:30:03.756+08:00
      roundId: `OP051-oct-${roundId}`, // OP051-oct-303107f3-0dd7-46aa-9e3c-00000000b88a
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        betType: '1',
        isEndRound: `${isEndRound}`,
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `OP051-oct-${roundId}_OP051-oct-${wagerId}`,
      roundId: `OP051-oct-${roundId}`,
      gameInfo: {
        betType: '1',
      },
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
